import { Close, Info } from '@mui/icons-material';
import { Box, Dialog, IconButton, Stack } from '@mui/material';
import Title from 'lib/designSystem/Title';
import { PortfolioTemplate } from 'lib/types/models';
import TemplateSelector from 'pages/BusinessProfile/Contracts/Portfolios/Components/CreatePortfolio/Components/TemplateSelector';
import React from 'react';

interface DetailsDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  template: PortfolioTemplate | null;
  refreshTemplates: () => Promise<void>;
}

const DetailsDialog = (props: DetailsDialogProps) => {
  const { open, setOpen, template, refreshTemplates } = props;

  if (!template) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 2.5, pt: 2 }}
      >
        <Title
          title={template.title ?? 'Detalle de plantilla'}
          icon={<Info color="primary" />}
          color="primary"
        />
        <IconButton aria-label="close" onClick={() => setOpen(false)}>
          <Close />
        </IconButton>
      </Stack>
      <Box mx={2} mb={2}>
        <TemplateSelector
          template={template}
          isEditable
          refreshTemplates={refreshTemplates}
        />
      </Box>
    </Dialog>
  );
};

export default DetailsDialog;
